var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTotalStaffIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 56,
    viewBox: "0 0 50 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9465 55.9963C14.8095 55.9963 15.6931 55.9913 16.5959 55.9913H33.6865C34.5881 55.9913 35.4716 55.9963 36.3347 55.9963C44.2425 55.9963 50.2849 55.5918 50.2849 47.325C50.2849 38.6723 43.6676 31.5691 35.2165 30.7969C35.1493 33.824 25.144 41.2944 25.144 41.2944C25.144 41.2944 15.1362 33.8246 15.0684 30.7975C6.61858 31.5691 0 38.6723 0 47.325C0 55.5918 6.03991 55.9963 13.9465 55.9963ZM32.6088 44.7073C32.6088 44.4609 32.8309 44.2624 33.1072 44.2624H35.8101V41.5607C35.8101 41.2869 36.0074 41.0623 36.2538 41.0623H38.9212C39.1664 41.0623 39.3649 41.2851 39.3649 41.5607V44.263H42.0666C42.3404 44.263 42.5644 44.4615 42.5644 44.7079V47.3741C42.5644 47.6205 42.3422 47.819 42.0666 47.819H39.3643V50.5207C39.3643 50.7957 39.1652 51.0185 38.9194 51.0185H36.2532C36.0068 51.0185 35.8083 50.7963 35.8083 50.5207V47.8184H33.1066C32.8316 47.8184 32.6082 47.6199 32.6082 47.3735L32.6088 44.7073Z",
    fill: "#6045EB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1501 32.9728C32.7935 32.9728 38.9889 21.4797 38.9889 13.837C38.9889 6.19547 32.7935 0 25.1501 0C17.508 0 11.3125 6.19547 11.3125 13.837C11.3125 21.4797 17.508 32.9728 25.1501 32.9728Z",
    fill: "#6045EB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalStaffIcon);
export default __webpack_public_path__ + "static/media/total-staff-icon.520b4589fc83599fb8d9b0e4d982cf90.svg";
export { ForwardRef as ReactComponent };